import { render, staticRenderFns } from "./LeavingAMessage.vue?vue&type=template&id=7d160fbc&"
import script from "./LeavingAMessage.vue?vue&type=script&lang=js&"
export * from "./LeavingAMessage.vue?vue&type=script&lang=js&"
import style0 from "./LeavingAMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports